import { createSelector } from "@reduxjs/toolkit";
import { helpers } from "../../../packages/helpers";
import { selectChatMessages } from "./select-chat-messages";

const { getStringValue } = helpers.text;

export const selectTopAndBottomMessageIds = createSelector(
  selectChatMessages,
  (messages) => {
    const topMessageId = getStringValue(messages[0]?.id, "top_message_id");
    const bottomMessageId = getStringValue(
      messages.slice(-1)[0]?.id,
      "bottom_message_id"
    );

    return {
      topMessageId,
      bottomMessageId,
    };
  }
);
